import * as tslib_1 from "tslib";
import { HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../../../core/services/ls-helper.service";
import * as i4 from "../../../core/services/auth.service";
import * as i5 from "../../../core/services/utils.service";
export class InspectionService extends BaseProvider {
    constructor(globals, http, ls, authService, utilsService) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.authService = authService;
        this.utilsService = utilsService;
        this.inspectionTypes = [];
        this.vehicle = {};
        this.itemToEdit = { Id: '' };
        this.vehicleSubject = new BehaviorSubject(null);
        this.currentVehicle = this.vehicleSubject.asObservable();
        this.inspectionEditSubject = new BehaviorSubject(null);
        this.currentInspectionEdit = this.vehicleSubject.asObservable();
        this.formData = {};
        this.baseUrl = 'inspection';
    }
    updateFormData() {
        console.log('this.mainService', this.vehicle);
        this.formData = {
            'MARCA': this.vehicle.Brand,
            'MODELO': this.vehicle.Model,
            'AÑO': this.vehicle.Year,
            'NÚMERO DE TABLILLA': this.vehicle.LicensePlate
        };
    }
    searchInspections(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/term/' + params.term +
                '/page/' + params.pageNumber +
                '/size/' + params.pageSize;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.list = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getVehicleByLicensePlate(licensePlate, typeOfSearch) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${this.baseUrl}/vehicle/${licensePlate}/${typeOfSearch}`;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.vehicle = data.Data;
                this.vehicleSubject.next(data.Data);
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    create(params) {
        console.log('params', params);
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    update(params, id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + id;
            this.http.put(this.url, params).subscribe((data) => {
                console.log('data inspection', data);
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getInspectionTypes() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/inspectionTypes';
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.inspectionTypes = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getById(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + id;
            this.http.get(this.url).subscribe((data) => {
                console.log('itemToEdit', data.Data);
                this.itemToEdit = data.Data;
                this.inspectionEditSubject.next(this.itemToEdit);
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    deleteInspection(inspectionId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/${inspectionId}`;
            this.http.delete(this.url).subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getPdf(id, fileType, autoLoad) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log('getPdf');
            const queryParams = new HttpParams()
                .set('fileName', id.toString());
            return yield new Promise((resolve, reject) => {
                this.url = this.globals.dataUrl + 'userProcessRequirement' + '/file';
                this.http
                    .get(this.url, { responseType: 'arraybuffer', params: queryParams })
                    .subscribe((data) => {
                    const url = this.downLoadFile(data, fileType, autoLoad);
                    resolve(url);
                }, err => { reject(err); });
            });
        });
    }
    downLoadFile(data, type, autoLoad) {
        const blob = new Blob([data], { type });
        const url = window.URL.createObjectURL(blob);
        if (autoLoad) {
            this.fileToLoad = url;
        }
        return url;
    }
    uploadInspectionPdfFile(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/file';
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    clearInspectionAndVehicleSubject() {
        this.vehicle = null;
        this.itemToEdit = null;
        this.inspectionEditSubject.complete();
        this.inspectionEditSubject = new BehaviorSubject(null);
        this.currentInspectionEdit = this.inspectionEditSubject.asObservable();
        this.vehicleSubject.complete();
        this.vehicleSubject = new BehaviorSubject(null);
        this.currentVehicle = this.inspectionEditSubject.asObservable();
    }
}
InspectionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InspectionService_Factory() { return new InspectionService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService), i0.ɵɵinject(i4.AuthService), i0.ɵɵinject(i5.UtilsService)); }, token: InspectionService, providedIn: "root" });
